import React from 'react';
import Header from '../../components/Header/Header';
import Hero2 from '../../components/Hero2/Hero2';
import Assortment from '../../components/Assortment/Assortment';
import Footer from '../../components/Footer/Footer';

const Page2 = () => {
  return (
    <div>
      <Header />
      <Hero2 />
      <Assortment />
      <Footer />
    </div>
  );
};

export default Page2;
